import { type IconProps, iconVariants } from '@/components/icons/common'

export function LoadingIcon({ className, size = 48, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 49"
      fill="currentColor"
      role="presentation"
      className={iconVariants({ size, className })}
      {...props}
    >
      <path d="M25.124 11.979a5.614 5.614 0 1 0 0-11.229 5.614 5.614 0 0 0 0 11.229Z" />
      <path d="M25.124 48.75a3.368 3.368 0 1 0 0-6.736 3.368 3.368 0 0 0 0 6.736Z" opacity=".6" />
      <path d="M11.33 17.13a5.053 5.053 0 1 0 0-10.106 5.053 5.053 0 0 0 0 10.106Z" opacity=".9" />
      <path d="M38.92 42.473a2.807 2.807 0 1 0 0-5.615 2.807 2.807 0 0 0 0 5.615Z" opacity=".5" />
      <path d="M5.615 30.364a4.49 4.49 0 1 0 0-8.98 4.49 4.49 0 0 0 0 8.98Z" opacity=".8" />
      <path d="M44.633 28.116a2.244 2.244 0 1 0 0-4.488 2.244 2.244 0 0 0 0 4.488Z" opacity=".4" />
      <path
        d="M8.552 36.891a3.926 3.926 0 0 0 0 5.556 3.926 3.926 0 0 0 5.556 0 3.926 3.926 0 0 0 0-5.556 3.91 3.91 0 0 0-5.556 0Z"
        opacity=".7"
      />
      <path d="M38.918 13.76a1.683 1.683 0 1 0 0-3.366 1.683 1.683 0 0 0 0 3.366Z" opacity=".3" />
    </svg>
  )
}
